import { ValueFormatterParams } from "ag-grid-community";
import { formatDateTime } from "../../../utils/format/formatDateTime";

export function dateTimeFormatter(params: ValueFormatterParams): string {
  return formatDateTime(params?.value);
}
